// Faixa global discreta (prêmios raros da Roleta e das bags): desliza no topo da tela do jogo, fica 6 s e some.
// Uma por vez, em fila (no máximo 4 esperando); não bloqueia cliques nem cobre o centro do mapa.
import { useEffect, useRef, useState } from 'preact/hooks';

export interface BannerMsg { text: string; icon: number }
export function useBanners() {
  const [cur, setCur] = useState<(BannerMsg & { k: number }) | null>(null);
  const queue = useRef<BannerMsg[]>([]), seq = useRef(0), busy = useRef(false);
  const next = () => {
    const m = queue.current.shift();
    if (!m) { busy.current = false; setCur(null); return; }
    busy.current = true; setCur({ ...m, k: ++seq.current });
    setTimeout(next, 6500);
  };
  const push = (m: BannerMsg) => { if (queue.current.length >= 4) queue.current.shift(); queue.current.push(m); if (!busy.current) next(); };
  return { cur, push };
}
export function Banner(props: { msg: (BannerMsg & { k: number }) | null; Img: (p: { typeId: number; count: number }) => preact.JSX.Element | null }) {
  const [hide, setHide] = useState(false);
  useEffect(() => setHide(false), [props.msg?.k]);
  if (!props.msg || hide) return null;
  return (
    <div key={props.msg.k} class="gbanner" onClick={() => setHide(true)} title="Clique para fechar">
      <span class="gbanner-icon"><props.Img typeId={props.msg.icon} count={1} /></span>
      <span class="gbanner-text">{props.msg.text}</span>
    </div>
  );
}
